export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4604.0add7d2e.jpg";